/**
 * Vue Store related to Subscription plans state information.
 *
 * @author Documill 2025
 */

import apiCall from '../../utils/api';
import { logger } from '../../utils/logger';

export default {

  state: {
    signers: [],
    // TODO: Move also tags here?
  },

  getters: {
    getOverlaySigners: (state) => {
      return state.signers;
    },
  },

  mutations: {
    setOverlaySigners(state, signers) {
      state.signers = signers;
    },

    addTemporaryOverlaySigner(state, temporarySigner) {
      state.signers.push(temporarySigner);
    },

    deleteOverlaySigner(state, id) {
      state.signers.splice(state.signers.findIndex(signer => signer.id === id),1);
    },

    replaceTemporaryOverlaySigner(state, params) {
      state.signers.splice(state.signers.indexOf(params.temporarySigner),1,params.signer);
    },

    updateOverlaySignerAfterLinking(state, params) {
      let signerId = params.signerId;
      let taskId = params.taskId;
      let previousSignerId = params.previousSignerId;

      state.signers.find(signer => signer.id === signerId).taskId = taskId;

      if(previousSignerId != null)
        state.signers.find(signer => signer.id === previousSignerId).taskId = null;
    },
  },

  actions: {
    async loadPhaseOverlaySigners(context,params) {
      try {
        let url = "v1/annotations/signature/signers/" + params.anchorId + "/" + params.phaseId;
        let result = await apiCall.get(url);
        let signers = result.data;

        context.commit("setOverlaySigners",signers);
      }
      catch(error) {
        logger.error("Loading phase signers failed:",error);

        throw error;
      }
    },

    async loadTaskOverlaySigner(context,params) {
      try {
        let url = "v1/annotations/signature/signer/" + params.taskOverlaySignerId;
        let result = await apiCall.get(url);
        let signer = result.data.taskSigner;
        let completedSigners = result.data.completedSigners;

        let signers = [signer,...completedSigners];

        context.commit("setOverlaySigners",signers);

        return signer;
      }
      catch(error) {
        logger.error("Loading task signers failed:",error);

        throw error;
      }
    },

    async reloadOverlaySigners(context,params) {
      let url = 'v1/documents/project/reload-signers';
      let result = await apiCall.post(url,params);
      let signers = result.data;

      context.commit("setOverlaySigners",signers);
    },

    async addOverlaySigner(context,params) {
      // Add signer to "signers" array right away so it will be visualized.

      let temporarySigner = {
        anchorId: params.anchorId,
        phaseId: params.phaseId,
        isTemporaryPlaceholder: true,
        signatureTags: [],
      };

      context.commit("addTemporaryOverlaySigner",temporarySigner);

      let apiCallParams = {
        anchorId: params.anchorId,
        phaseId: params.phaseId,
      };

      let result = await apiCall.post("v1/annotations/signature/signer", apiCallParams);
      let signer = result.data;

      // Replace the temporary signer from "signers" array and push the signer returned from API.

      context.commit("replaceTemporaryOverlaySigner",{temporarySigner,signer});
    },

    async deleteOverlaySigner(context,id) {
      // Delete the signer from "signers" array right away to visualize the removal.

      context.commit("deleteOverlaySigner",id);

      await apiCall.delete("v1/annotations/signature/signer/" + id);
    },

    async linkOverlaySigner(context,params) {
      let signerId = params.signerId;
      let previousSignerId = params.previousSignerId;
      let taskId = params.taskId;

      let url;
      if(taskId != null) { // Link to task?
        // Backend will unlink previous signer, if any, automatically (FLOW-4124).
        url = "v1/annotations/signature/signer/" + signerId + "/link/" + taskId;
      }
      else { // Unlink
        url = "v1/annotations/signature/signer/" + signerId + "/unlink";
      }

      context.commit("updateOverlaySignerAfterLinking",{
        signerId: signerId,
        taskId: taskId,
        previousSignerId: previousSignerId
      });

      await apiCall.put(url);
    }
  },

}
